import { render, staticRenderFns } from "./download-failed-notification.vue?vue&type=template&id=2b6a27ed&"
import script from "./download-failed-notification.vue?vue&type=script&lang=js&"
export * from "./download-failed-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports